import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Flooring', path: '/flooring-installation' },
  { label: 'Bathroom', path: '/bathroom-remodeling' },
  { label: 'Commercial', path: '/commercial' },
  { label: 'Our Work', path: '/portfolio' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed left-0 w-full z-50 transition-all duration-300 top-9 ${
        scrolled ? 'bg-white/95 backdrop-blur-md border-b border-[#e5e0d8] !top-0' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/3fe83e6a-84e4-4c94-acd9-54d43e9a8906.png"
            alt="VM General Construction LLC"
            className="h-[4.5rem] w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium tracking-wide transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? 'text-[#c9a55a]'
                  : scrolled ? 'text-[#4a4540] hover:text-[#1c1a17]' : 'text-white/80 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Phone + CTA */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="tel:+19044019383"
            className={`flex items-center gap-2 text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-[#4a4540] hover:text-[#c9a55a]' : 'text-white/80 hover:text-white'
            }`}
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-[#c9a55a] text-sm" />
            </div>
            (904) 401-9383
          </a>
          <Link
            to="/contact"
            className="flex items-center gap-2 bg-[#c9a55a] hover:bg-[#b8944a] text-[#0d0d0d] font-bold text-sm px-6 py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
          >
            Get Free Estimate
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white/98 border-t border-[#e5e0d8] px-6 py-6 flex flex-col gap-4">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-base font-medium py-2 cursor-pointer ${
                location.pathname === link.path ? 'text-[#c9a55a]' : 'text-[#4a4540]'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="mt-2 bg-[#c9a55a] text-[#0d0d0d] font-bold text-sm px-6 py-3 rounded-lg text-center whitespace-nowrap cursor-pointer"
          >
            Get Free Estimate
          </Link>
        </div>
      )}
    </header>
  );
}
